import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Home } from 'tabler-icons-react';
import LogoNovaLight from '../../logos/LogoNovaLight.svg';
import '../../styles/notfound.css';

const isNova = process.env.REACT_APP_THEME === 'novaTheme' || !process.env.REACT_APP_THEME;

export default function NotFound() {
    const history = useHistory();

    return (
        <div className={`nf-page${isNova ? ' nf-page--nova' : ''}`}>
            <div className="nf-card">
                {/* ── Illustration ── */}
                <svg className="nf-illus" viewBox="0 0 400 280" aria-hidden="true">
                    {/* Gear — outer ring dashed */}
                    <circle
                        cx="200" cy="95" r="75"
                        fill="none" stroke="#fff" strokeWidth="3"
                        strokeDasharray="8 6" opacity="0.18"
                    />
                    {/* Gear — inner ring dashed */}
                    <circle
                        cx="200" cy="95" r="42"
                        fill="none" stroke="#fff" strokeWidth="2.5"
                        strokeDasharray="5 5" opacity="0.12"
                    />
                    {/* Gear — connector bolts */}
                    {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
                        const rad = (angle * Math.PI) / 180;
                        const cx = 200 + 75 * Math.cos(rad);
                        const cy = 95 + 75 * Math.sin(rad);
                        return (
                            <rect
                                key={angle}
                                x={cx - 6} y={cy - 6} width={12} height={12} rx={2}
                                fill="#fff" opacity="0.15"
                                transform={`rotate(${angle} ${cx} ${cy})`}
                            />
                        );
                    })}
                    {/* N logo inside gear */}
                    <g transform="translate(182, 83) scale(1.05)">
                        <path
                            d="m27.5 22.5l-24.6-18.6v18.6h-2.9v-22.5h2.9l23.3 18v-18h2.9v22.5z"
                            fill="#fff" opacity="0.25"
                        />
                    </g>

                    {/* Conveyor belt */}
                    <rect x="50" y="220" width="300" height="7" rx="3.5" fill="#fff" opacity="0.18" />
                    {/* Conveyor rollers */}
                    {[90, 150, 210, 270, 330].map((x) => (
                        <circle key={x} cx={x} cy="231" r="5" fill="#fff" opacity="0.1" />
                    ))}

                    {/* Pieces on conveyor */}
                    <rect x="72" y="192" width="34" height="28" rx="4" fill="#fff" opacity="0.2" />
                    <rect x="118" y="192" width="34" height="28" rx="4" fill="#fff" opacity="0.2" />
                    {/* Missing piece — dashed */}
                    <rect
                        x="173" y="190" width="38" height="30" rx="5"
                        fill="none" className="nf-missing-piece"
                        strokeWidth="2.5" strokeDasharray="6 4"
                    />
                    <text
                        x="192" y="211" textAnchor="middle"
                        className="nf-missing-text"
                        fontSize="18" fontWeight="700"
                        fontFamily="WorkSans, sans-serif"
                    >
                        ?
                    </text>
                    <rect x="232" y="192" width="34" height="28" rx="4" fill="#fff" opacity="0.2" />
                    <rect x="278" y="192" width="34" height="28" rx="4" fill="#fff" opacity="0.2" />

                    {/* Sparkles around missing piece */}
                    <circle cx="178" cy="185" r="2" className="nf-spark nf-spark--1" />
                    <circle cx="208" cy="183" r="1.5" className="nf-spark nf-spark--2" />
                    <circle cx="195" cy="225" r="1.5" className="nf-spark nf-spark--3" />

                    {/* Industrial banner — on top of everything */}
                    <g transform="translate(118, -8)">
                        <rect x="-8" y="6" width="10" height="16" rx="2" fill="#fff" opacity="0.2" />
                        <rect x="162" y="6" width="10" height="16" rx="2" fill="#fff" opacity="0.2" />
                        <rect x="-8" y="26" width="10" height="16" rx="2" fill="#fff" opacity="0.2" />
                        <rect x="162" y="26" width="10" height="16" rx="2" fill="#fff" opacity="0.2" />
                        <rect width="164" height="44" rx="4" className="nf-banner-bg" />
                        <rect x="0" y="0" width="9" height="44" rx="2" className="nf-banner-stripe" />
                        <rect x="155" y="0" width="9" height="44" rx="2" className="nf-banner-stripe" />
                        <text
                            x="82" y="30" textAnchor="middle"
                            fill="var(--color-primary)" fontSize="17" fontWeight="800"
                            fontFamily="WorkSans, sans-serif"
                            letterSpacing="0.1em"
                        >
                            ERROR 404
                        </text>
                    </g>
                </svg>

                <h1 className="nf-code">
                    4<span className="nf-accent">0</span><span className="nf-four-right">4</span>
                </h1>
                <h2 className="nf-title">Página fuera de línea</h2>
                <p className="nf-desc">
                    Esta sección no está disponible o fue reubicada.
                    Si crees que es un error, contacta al administrador.
                </p>

                <div className="nf-actions">
                    <Button
                        variant="contained"
                        className="nf-btn-primary"
                        startIcon={<Home size={16} />}
                        onClick={() => history.push('/')}
                    >
                        Ir al panel principal
                    </Button>
                    <Button
                        variant="outlined"
                        className="nf-btn-ghost"
                        onClick={() => history.goBack()}
                    >
                        Volver
                    </Button>
                </div>

                <img src={LogoNovaLight} alt="NOVA" className="nf-logo" />
            </div>
        </div>
    );
}
